import updateEventBus from "./updateEventBus.js";

// Service Worker Update Management
class ServiceWorkerUpdateManager {
  constructor() {
    this.registration = null;
    this.init();
  }

  async init() {
    if ("serviceWorker" in navigator) {
      try {
        this.registration = await navigator.serviceWorker.getRegistration();
        if (this.registration) {
          this.setupEventListeners();
          this.checkForUpdates();
        }
      } catch (error) {
        console.error("Service Worker registration failed:", error);
      }
    }
  }

  setupEventListeners() {
    // Listen for service worker updates
    this.registration.addEventListener("updatefound", () => {
      const newWorker = this.registration.installing;
      console.log("Service Worker update found, starting download...");
      updateEventBus.emit("updateAvailable", { downloaded: false });

      newWorker.addEventListener("statechange", () => {
        if (newWorker.state === "installed") {
          if (navigator.serviceWorker.controller) {
            // Emit event for update available
            updateEventBus.emit("updateAvailable", { downloaded: true });

            // Check if the update is downloaded
            this.checkUpdateStatus();
          }
        }
      });
    });

    // Listen for controller change (new service worker takes control)
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      // Emit event for update applied
      updateEventBus.emit("updateApplied");
    });

    // Listen for messages from service worker
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data && event.data.type === "SKIP_WAITING") {
        this.skipWaiting();
      }
    });
  }

  async checkForUpdates() {
    if (this.registration) {
      try {
        await this.registration.update();
      } catch (error) {
        console.error("Error checking for updates:", error);
      }
    }
  }

  async checkUpdateStatus() {
    if (this.registration && this.registration.waiting) {
      // Check if the waiting service worker has finished downloading
      const waitingWorker = this.registration.waiting;

      // Wait a bit to ensure the worker has finished downloading
      setTimeout(() => {
        if (waitingWorker.state === "installed") {
          console.log("Update downloaded and ready");

          // Emit event for update downloaded
          updateEventBus.emit("updateDownloaded", { ready: true });
        }
      }, 1000);
    }
  }

  async skipWaiting() {
    if (this.registration && this.registration.waiting) {
      // Send message to waiting service worker to skip waiting
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  }

  // Force check for updates
  async forceUpdateCheck() {
    await this.checkForUpdates();
  }

  // Get current service worker state
  getState() {
    return {
      hasRegistration: !!this.registration
    };
  }
}

// Create singleton instance
const serviceWorkerManager = new ServiceWorkerUpdateManager();

export default serviceWorkerManager;
